import emitter from "@webcore/core/events/eventemitter";
import * as Sentry from "@sentry/react";

 if (!import.meta.env.DEV) {
   Sentry.init({
     dsn: "https://3f9f19340a03007df5b3ad6c930f20a4@o1388406.ingest.us.sentry.io/4509131914805248",
     integrations: [Sentry.browserTracingIntegration()],
     tracesSampleRate: 1.0,
   });
 }

emitter.on("ui-ready", () => {
  import("./main.app");
});

emitter.on("initialized", () => {
  emitter.emit("load");
});

import("./app");
